<template>
  <div class="container">
    <van-list
      v-model="loading"
      :finished="finished"
      :error.sync="error"
      error-text="请求失败，点击重新加载"
      @load="getMobileLiveList()"
    >
      <div class="liveItem" v-for="(item, index) in list" :key="index">
        <mini-program
          :path="
            '/subpackagelive/pages/liveDetail/liveDetail?id=' + item.LiveId
          "
        >
          <van-image fit="cover" :src="item.Cover" />
          <div class="liveStatus">
            <img src="../../../static/images/index/status.gif" />
            <span>直播</span>
          </div>
          <div class="rightBox">
            <div class="title overFlowTwo">{{ item.Title }}</div>
            <div class="storeBox">
              <van-image
                fit="cover"
                :src="item.HeadlineLogo"
                round
                error-icon="https://cdn.alighting.com/cover/defaultPhoto.png"
              />
              <div class="name overFlowOne">{{ item.Headline }}</div>
              <div class="visitBtn">去围观</div>
            </div>
          </div>
        </mini-program>
      </div>
    </van-list>
  </div>
</template>
<script>
import { List, Image } from "vant";
import { getShareData } from "@/utils/share";
import { mobileLiveList } from "@/api/online";
import miniProgram from "@/components/miniProgram";
export default {
  name: "liveOnline",
  components: {
    "van-list": List,
    "van-image": Image,
    miniProgram,
  },
  data() {
    return {
      list: [],
      pageIndex: 1,
      total: 0,
      error: false,
      loading: false,
      finished: false,
    };
  },
  methods: {
    getMobileLiveList() {
      var that = this;
      var data = {
        CategoryId: 0,
        MemberId: 0,
        Keyword: "",
        Page: {
          PageSize: 15,
          PageIndex: that.pageIndex,
        },
        Recommend: -1,
        SpecialId: -1,
        HasQrcode: 1,
        Status: 0,
      };
      mobileLiveList(data)
        .then((res) => {
          if (that.pageIndex == 1) {
            that.list = [...res.Data.List];
          } else {
            that.list = [...that.list, ...res.Data.List];
          }
          that.total = res.Data.Total;
          that.pageIndex += 1;
          that.loading = false;
          if (that.list.length >= that.total) {
            that.finished = true;
          }
        })
        .catch((err) => {
          that.loading = false;
          that.error = true;
          that.Common.showMsg(err);
        });
    },
  },
  mounted() {
    getShareData(window.location.href, "2026阿拉丁网上照明展正在直播");
  },
};
</script>
